import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NeuSelect } from "../../components/neu/Neu";

// فلاتر متتالية: الفرع يُضيّق الأقسام والموظفين؛ القسم يُضيّق الموظفين. أي فلتر فارغ = الكل.
export const AudiencePicker = ({ filters, setFilters, lists }) => {
  const { t } = useTranslation();
  const label = (o) => o.name_ar || o.name || o.name_en || o.email || o.id;

  const depts = useMemo(
    () => lists.departments.filter((d) => !filters.branch || !d.branch_id || d.branch_id === filters.branch),
    [lists.departments, filters.branch]
  );
  const emps = useMemo(
    () =>
      lists.employees.filter(
        (e) =>
          (!filters.branch || (e.branch_ids || []).includes(filters.branch)) &&
          (!filters.department || (e.department_ids || []).includes(filters.department))
      ),
    [lists.employees, filters.branch, filters.department]
  );

  return (
    <div className="grid gap-4 sm:grid-cols-3" data-testid="notify-audience">
      <label className="grid gap-2">
        <span className="label-xs text-sm sm:text-xs">{t("notify.filterBranch")}</span>
        <NeuSelect data-testid="notify-branch" value={filters.branch} onChange={(e) => setFilters({ branch: e.target.value, department: "", employee: "" })}>
          <option value="">{t("notify.allBranches")}</option>
          {lists.branches.map((b) => <option key={b.id} value={b.id}>{label(b)}</option>)}
        </NeuSelect>
      </label>
      <label className="grid gap-2">
        <span className="label-xs text-sm sm:text-xs">{t("notify.filterDept")}</span>
        <NeuSelect data-testid="notify-dept" value={filters.department} onChange={(e) => setFilters({ ...filters, department: e.target.value, employee: "" })}>
          <option value="">{t("notify.allDepts")}</option>
          {depts.map((d) => <option key={d.id} value={d.id}>{label(d)}</option>)}
        </NeuSelect>
      </label>
      <label className="grid gap-2">
        <span className="label-xs text-sm sm:text-xs">{t("notify.filterEmployee")}</span>
        <NeuSelect data-testid="notify-employee" value={filters.employee} onChange={(e) => setFilters({ ...filters, employee: e.target.value })}>
          <option value="">{t("notify.allEmployees")}</option>
          {emps.map((p) => <option key={p.id} value={p.id}>{label(p)}</option>)}
        </NeuSelect>
      </label>
    </div>
  );
};
